
export default {
    methods: {
        showError: function (title, body) {
            this.$snotify.error(body, title, { 
                position: "centerTop",
                showProgressBar: false,
                timeout: 2000,
            });
        },
        showSuccess: function (title, body) {
            this.$snotify.success(body, title, { 
                position: "rightTop",
                timeout: 1000,
                showProgressBar: false,
            });
        },
        showConfirm: function(title, body, options) { //action
            var sidebar = document.querySelector('.page__sidebar');
            
            var defaultOptions = { 
                position: "centerCenter",
                timeout: 0,
                backdrop: 0.5,
            }

            if (typeof options === "function") {
                defaultOptions.buttons = [
                    {text: 'Yes', action: options, bold: false},
                    {text: 'No', bold: true}
                ]
            } else {
                defaultOptions = Object.assign(defaultOptions, options);
            }

            var toast = this.$snotify.confirm(body, title, defaultOptions);
            
            toast.eventEmitter.$on('beforeShow', () => sidebar.style.zIndex = 1);
            toast.eventEmitter.$on('hidden', () => sidebar.style.zIndex = 2);
        },
    }
};

